(() => {
  'use strict';

  const MEDIA_SELECTOR = 'img, video';

  const isMedia = (target) =>
    target instanceof Element &&
    Boolean(target.closest(MEDIA_SELECTOR));

  const protectVideos = (root) => {
    const videos = [];

    if (root instanceof HTMLVideoElement) {
      videos.push(root);
    }

    if (typeof root.querySelectorAll === 'function') {
      videos.push(...root.querySelectorAll('video'));
    }

    videos.forEach((video) => {
      const controls = new Set(
        (video.getAttribute('controlslist') || '')
          .split(/\s+/)
          .filter(Boolean)
      );

      controls.add('nodownload');
      video.setAttribute('controlslist', [...controls].join(' '));
    });
  };

  const init = () => {
    /* No interferir con el editor visual de Shopify */
    if (window.Shopify && window.Shopify.designMode) return;

    document.documentElement.classList.add('td-media-protection');

    /* Bloquea clic derecho únicamente sobre imágenes y videos */
    document.addEventListener(
      'contextmenu',
      (event) => {
        if (isMedia(event.target)) {
          event.preventDefault();
        }
      },
      { capture: true }
    );

    /* Evita arrastrar el archivo al escritorio */
    document.addEventListener(
      'dragstart',
      (event) => {
        if (isMedia(event.target)) {
          event.preventDefault();
        }
      },
      { capture: true }
    );

    protectVideos(document);

    /*
     * Protege videos añadidos dinámicamente por:
     * cart drawer, quick view, variantes y aplicaciones.
     */
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            protectVideos(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();